import NewTerminal from "./NewTerminal";

export default NewTerminal;